function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M349.805 78.2221H296.33C289.092 58.6296 285.949 40.4123 296.33 26.7377C296.33 23.2265 297.022 19.7496 298.365 16.5056C299.709 13.2617 301.678 10.3141 304.161 7.8313C306.644 5.34847 309.592 3.37899 312.836 2.03529C316.08 0.691598 319.556 7.3502e-06 323.068 7.3502e-06H323.068C327.335 -0.00315842 331.541 1.01636 335.333 2.97314C339.125 4.92993 342.393 7.767 344.863 11.2467C349.089 17.1812 349.936 24.8313 347.513 31.7017C343.194 43.9465 345.831 60.6549 349.805 78.2221Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378.048 271.217C376.5 271.217 374.994 270.721 373.749 269.802C372.504 268.882 371.587 267.588 371.131 266.109L368.928 258.949C368.419 257.292 368.321 255.536 368.643 253.833L370.143 245.902H380.668L385.035 262.097C385.324 263.169 385.363 264.294 385.147 265.384C384.932 266.474 384.468 267.5 383.793 268.382C383.117 269.263 382.247 269.978 381.251 270.47C380.255 270.962 379.159 271.217 378.048 271.217V271.217Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.368 271.217C302.915 271.217 304.422 270.721 305.667 269.802C306.912 268.882 307.829 267.588 308.284 266.109L310.487 258.949C310.997 257.292 311.095 255.536 310.773 253.833L309.272 245.902H298.748L294.381 262.097C294.091 263.169 294.053 264.294 294.268 265.384C294.484 266.474 294.947 267.5 295.623 268.382C296.299 269.263 297.168 269.978 298.164 270.47C299.161 270.962 300.257 271.217 301.368 271.217V271.217Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.521 246.755H369.859L319.228 150.613L309.887 246.755H299.601C294.324 186.213 281.486 128.544 299.601 106.809L341.983 110.791L381.521 246.755Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M321.646 41.8133C329.5 41.8133 335.868 35.4458 335.868 27.5911C335.868 19.7364 329.5 13.3689 321.646 13.3689C313.791 13.3689 307.423 19.7364 307.423 27.5911C307.423 35.4458 313.791 41.8133 321.646 41.8133Z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.699 82.3465H310.126L304.721 57.3155C315.206 54.2179 317.706 47.0135 315.53 37.4044L332.597 36.2666C333.564 44.007 335.334 51.2243 346.25 52.4799L341.699 82.3465Z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.699 113.635C323.786 120.437 309.213 120.225 299.032 110.791C303.626 95.6409 303.901 76.9849 301.877 56.4621L307.566 53.9021L309.557 72.1065L337.717 70.6843L343.974 50.7732L350.232 52.1954C350.712 76.8823 349.233 99.091 341.699 113.635Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.197 144.355L361.541 155.225C361.812 156.106 361.873 157.038 361.718 157.946C361.563 158.854 361.197 159.713 360.65 160.454C360.102 161.196 359.389 161.798 358.566 162.213C357.744 162.628 356.835 162.844 355.914 162.844V162.844C355.089 162.844 354.273 162.671 353.52 162.336C352.766 162 352.092 161.51 351.54 160.898C350.988 160.285 350.57 159.563 350.315 158.779C350.06 157.994 349.972 157.165 350.058 156.345L351.37 143.786L345.966 101.12L349.948 82.3466H359.903L358.197 144.355Z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.531 142.095L272.653 151.831C272.177 152.619 271.893 153.509 271.823 154.428C271.753 155.346 271.9 156.269 272.251 157.12C272.603 157.972 273.15 158.729 273.847 159.331C274.545 159.933 275.374 160.363 276.268 160.586C277.068 160.786 277.901 160.815 278.714 160.672C279.526 160.529 280.299 160.217 280.983 159.756C281.667 159.296 282.247 158.696 282.684 157.997C283.122 157.298 283.408 156.515 283.523 155.698L285.292 143.196L300.869 103.108L304.01 83.911L291.893 81.5184L278.531 142.095Z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M367.014 84.6221L348.241 84.3377V51.6266L351.132 52.0481C354.199 52.4955 357.028 53.9616 359.162 56.2106C361.296 58.4596 362.611 61.361 362.897 64.4481L367.014 84.6221Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.801 88.0354L305.575 87.751V55.0399L302.684 55.4615C299.616 55.9089 296.788 57.3749 294.654 59.6239C292.52 61.873 291.204 64.7743 290.918 67.8614L286.801 88.0354Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.73 20.7644C328.688 24.1827 317.078 25.7463 308.561 23.3244L305.717 8.53333H333.877L334.73 20.7644Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.068 196.327H18.4344V270.987H111.068V196.327Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.5858 249.326H56.9165V270.526H72.5858V249.326Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.913 198.532L227.378 191.957L250.39 178.808L266.005 175.521L224.913 198.532Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.264 198.532L137.799 191.957L114.787 178.808L99.1725 175.521L140.264 198.532Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.557 200.175H138.62L131.224 165.659H233.953L226.557 200.175Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M226.557 200.175H138.62L131.224 165.659H233.953L226.557 200.175Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.967 198.121H138.209V270.987H226.967V198.121Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.423 249.316H174.754V270.515H190.423V249.316Z",
  fill: "#3D5651"
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.818 271.074H0V270.069H400L399.818 271.074Z",
  fill: "#3D5651"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.023 213.033H164.154V224.555H201.023V213.033Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.9411 213.033H46.0721V224.555H82.9411V213.033Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 400,
  height: 271.217,
  fill: "white"
})));

function SvgStockImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 272,
    viewBox: "0 0 400 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockImg);
export default __webpack_public_path__ + "static/media/stock-img.35872e56.svg";
export { ForwardRef as ReactComponent };